// Shopify's native customer form saves the email and handles its own spam challenge.
// Only its server-rendered success marker unlocks the free-pair offer.
(() => {
  const offer = window.ollawayFreePair;
  if (!offer) return;
  let pageOfferShown = false;
  const sessionKey = 'ollaway_free_pair_seen_v1';

  function revealTiers() {
    if (!offer.unlocked()) return;
    document.querySelectorAll('[data-ol-free-pair]').forEach(card => {
      card.hidden = false;
      const input = card.querySelector('[data-ol-tier]');
      input.disabled = input.dataset.olAvailable !== 'true';
    });
  }

  class Gift {
    constructor(root) {
      this.root = root;
      this.dialog = root.querySelector('[data-olg-dialog]');
      this.row = root.querySelector('[data-olg-open]');
      this.form = root.querySelector('[data-olg-form]');
      this.done = root.querySelector('[data-olg-done]');
      this.buyable = root.dataset.buyable === 'true';
      this.root.hidden = false;
      this.row.addEventListener('click', () => this.open());
      root.querySelectorAll('[data-olg-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('olq-locked');
        const target = this.row.hidden ? document.querySelector('[data-ol-free-pair] input:not([disabled])') : this.row;
        target?.focus({ preventScroll: true });
      });
      if (offer.unlocked()) this.showClaimed();
      else if (root.querySelector('[data-olg-signup-success]')) this.confirmSignup();
      else if (this.form.querySelector('.errors')) this.open();
    }

    open() {
      if (this.dialog.open || typeof this.dialog.showModal !== 'function') return;
      document.documentElement.classList.add('olq-locked');
      this.dialog.showModal();
      (this.done.hidden ? this.form.querySelector('[data-olg-email]') : this.done.querySelector('h3'))?.focus({ preventScroll: true });
    }

    showClaimed() {
      this.row.hidden = true;
      this.root.querySelector('[data-olg-claimed]').hidden = false;
      this.form.hidden = true;
      this.root.querySelector('.olg-dialog__head').hidden = true;
      this.done.querySelector('h3').id = `${this.dialog.id}-success`;
      this.dialog.setAttribute('aria-labelledby', this.done.querySelector('h3').id);
      this.done.hidden = false;
      revealTiers();
    }

    async confirmSignup() {
      offer.unlock();
      this.showClaimed();
      try {
        await offer.apply();
        if (this.root.dataset.context === 'cart') { location.replace('/cart'); return; }
      } catch {
        const code = JSON.parse(this.root.querySelector('[data-olg-config]').textContent).code;
        location.assign(`/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(this.root.dataset.context === 'cart' ? '/cart' : '/#ollaway-offer')}`);
        return;
      }
      this.open();
    }
  }

  function showPageLoadOffer() {
    if (pageOfferShown || offer.unlocked() || document.visibilityState !== 'visible') return;
    try { if (sessionStorage.getItem(sessionKey)) return; } catch {}
    if (document.querySelector('dialog[open], cart-drawer.active, .cart-notification.active, menu-drawer details[open], .ollaway-chat-panel:not([hidden])')) return;
    const gift = [...document.querySelectorAll('[data-ol-gift]')].map(root => root.olg).find(gift => gift?.buyable && !gift.root.hidden);
    if (!gift) return;
    gift.open();
    pageOfferShown = true;
    try { sessionStorage.setItem(sessionKey, '1'); } catch {}
  }

  function start(scope = document) {
    scope.querySelectorAll('[data-ol-gift]').forEach(root => { if (!root.olg) root.olg = new Gift(root); });
    revealTiers();
    showPageLoadOffer();
  }
  document.addEventListener('ollaway:free-pair', () => {
    revealTiers();
    document.querySelectorAll('[data-ol-gift]').forEach(root => root.olg?.showClaimed());
  });
  document.addEventListener('visibilitychange', showPageLoadOffer);
  document.addEventListener('shopify:section:load', event => start(event.target));
  document.addEventListener('ollaway:refresh', () => start());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start());
  else start();
})();
